import {
  POS_CR_LOADING,
  POS_CR_SESSION,
  POS_CR_TRANSACTIONS,
  POS_CR_LAST_Z,
  POS_CR_ERROR,
} from "./actionTypes";

const initialState = {
  loading: false,
  session: null,
  report: null, // live X report for the open session
  transactions: [],
  lastZReport: null,
  error: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case POS_CR_LOADING:
      return { ...state, loading: action.payload, error: null };
    case POS_CR_SESSION:
      return {
        ...state,
        loading: false,
        session: action.payload.session || null,
        report: action.payload.report || null,
        error: null,
      };
    case POS_CR_TRANSACTIONS:
      return { ...state, transactions: action.payload };
    case POS_CR_LAST_Z:
      return { ...state, lastZReport: action.payload };
    case POS_CR_ERROR:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}
